import styled from "styled-components";

/** 버튼 래퍼 - flex row, gap 8px */
export const ManageBtns = styled.div`
  display: flex;
  gap: 8px;
`;

/** 기본 버튼 - 흰 배경, 회색 테두리 */
export const SmallBtn = styled.button`
  height: 32px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  background: #fff;
  font-size: 13px;
  font-weight: 500;
  color: #333;
  cursor: pointer;
  transition: all 0.15s ease;
  width: max-content;

  &:hover:not(:disabled) {
    background: #f5f5f5;
    border-color: #ccc;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

/** Primary 버튼 - #546E7A 배경, 흰 글자 */
export const PrimaryBtn = styled(SmallBtn)`
  background: #546e7a;
  color: #fff;
  border: none;

  &:hover:not(:disabled) {
    background: #455a64;
  }
`;

/** Danger 버튼 - 빨간 테두리, 빨간 글자 */
export const DangerBtn = styled(SmallBtn)`
  border-color: #ffdddd;
  color: #c40000;
  background: #fff;

  &:hover:not(:disabled) {
    background: #fff5f5;
    border-color: #ffcccc;
  }
`;

/** 테이블 래퍼 - 테두리, 둥근 모서리, 스크롤 */
export const TableWrap = styled.div`
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 10px;
`;

/** 테이블 스타일 */
export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    border-bottom: 1px solid #f1f1f1;
    padding: 10px 12px;
    font-size: 13px;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
  }

  th {
    position: sticky;
    top: 0;
    background: #fafafa;
    z-index: 1;
    font-weight: 700;
    /* 헤더 좌우정렬 통일 (가운데) */
    text-align: center;
  }

  tbody tr:hover {
    background: #fafafa;
  }
`;

/** 빈 데이터 박스 */
export const EmptyBox = styled.div`
  padding: 22px;
  text-align: center;
  color: #777;
`;

/** 로딩 박스 */
export const LoadingBox = styled.div`
  padding: 22px;
  text-align: center;
  color: #666;
`;
